(function ($, window) {

var url = '/api/user';
var v = window.location.search.match(new RegExp('(?:[\?\&]code=)([^&]+)'));

if (v) {
  url += '?code='+v[1];
}

$.get(url)
  .done(function (data) {
    var user = {
      logged: false,
      userName: ''
    };

    if (typeof data == 'object') {
      user = data;
    }

    window.setUser(user)
  })
  .fail(function (jqXHR, textStatus) {
    console.warn('/api/user request failed: ' + textStatus);
  })
;

})(jQuery, window, document);
